import React, { FC, PureComponent } from 'react';
import { styled } from 'linaria/react';
import { theme } from '@mtsbank/ui-kit/build/theme/';
interface Props {
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  paddingTop?: number;
  paddingRight?: number;
  paddingBottom?: number;
  paddingLeft?: number;
}
interface StaticProps {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  mobTop?: number;
  mobRight?: number;
  mobBottom?: number;
  mobLeft?: number;
  minTop?: number;
  minRight?: number;
  minBottom?: number;
  minLeft?: number;
}
export class Content extends PureComponent<Props> {
  static Padding: FC<StaticProps> = ({
    children,
    top,
    mobTop,
    minTop,
    right,
    mobRight,
    minRight,
    bottom,
    mobBottom,
    minBottom,
    left,
    mobLeft,
    minLeft
  }) => <PaddingWrapper top={top} mobTop={mobTop} minTop={minTop} right={right} mobRight={mobRight} minRight={minRight} bottom={bottom} mobBottom={mobBottom} minBottom={minBottom} left={left} mobLeft={mobLeft} minLeft={minLeft}>
      {children}
    </PaddingWrapper>;
  static Margin: FC<StaticProps> = ({
    children,
    top,
    mobTop,
    minTop,
    right,
    mobRight,
    minRight,
    bottom,
    mobBottom,
    minBottom,
    left,
    mobLeft,
    minLeft
  }) => <MarginWrapper top={top} mobTop={mobTop} minTop={minTop} right={right} mobRight={mobRight} minRight={minRight} bottom={bottom} mobBottom={mobBottom} minBottom={minBottom} left={left} mobLeft={mobLeft} minLeft={minLeft}>
      {children}
    </MarginWrapper>;
  render() {
    const {
      children,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      paddingTop,
      paddingRight,
      paddingLeft,
      paddingBottom
    } = this.props;
    return <Wrapper marginTop={marginTop} marginRight={marginRight} marginBottom={marginBottom} marginLeft={marginLeft} paddingTop={paddingTop} paddingRight={paddingRight} paddingBottom={paddingBottom} paddingLeft={paddingLeft}>
        {children}
      </Wrapper>;
  }
}
const PaddingWrapper = /*#__PURE__*/styled("div")({
  name: "PaddingWrapper",
  class: "p1uu1zsw",
  vars: {
    "p1uu1zsw-0": [({
      minTop
    }) => minTop ? `${minTop}px` : 0],
    "p1uu1zsw-1": [({
      minRight
    }) => minRight ? `${minRight}px` : 0],
    "p1uu1zsw-2": [({
      minBottom
    }) => minBottom ? `${minBottom}px` : 0],
    "p1uu1zsw-3": [({
      minLeft
    }) => minLeft ? `${minLeft}px` : 0],
    "p1uu1zsw-5": [({
      mobTop
    }) => mobTop ? `${mobTop}px` : 0],
    "p1uu1zsw-6": [({
      mobRight
    }) => mobRight ? `${mobRight}px` : 0],
    "p1uu1zsw-7": [({
      mobBottom
    }) => mobBottom ? `${mobBottom}px` : 0],
    "p1uu1zsw-8": [({
      mobLeft
    }) => mobLeft ? `${mobLeft}px` : 0],
    "p1uu1zsw-10": [({
      top
    }) => top ? `${top}px` : 0],
    "p1uu1zsw-11": [({
      right
    }) => right ? `${right}px` : 0],
    "p1uu1zsw-12": [({
      bottom
    }) => bottom ? `${bottom}px` : 0],
    "p1uu1zsw-13": [({
      left
    }) => left ? `${left}px` : 0]
  }
});
const MarginWrapper = /*#__PURE__*/styled("div")({
  name: "MarginWrapper",
  class: "m1g7c6eq",
  vars: {
    "m1g7c6eq-0": [({
      minTop
    }) => minTop ? `${minTop}px` : 0],
    "m1g7c6eq-1": [({
      minRight
    }) => minRight ? `${minRight}px` : 0],
    "m1g7c6eq-2": [({
      minBottom
    }) => minBottom ? `${minBottom}px` : 0],
    "m1g7c6eq-3": [({
      minLeft
    }) => minLeft ? `${minLeft}px` : 0],
    "m1g7c6eq-5": [({
      mobTop
    }) => mobTop ? `${mobTop}px` : 0],
    "m1g7c6eq-6": [({
      mobRight
    }) => mobRight ? `${mobRight}px` : 0],
    "m1g7c6eq-7": [({
      mobBottom
    }) => mobBottom ? `${mobBottom}px` : 0],
    "m1g7c6eq-8": [({
      mobLeft
    }) => mobLeft ? `${mobLeft}px` : 0],
    "m1g7c6eq-10": [({
      top
    }) => top ? `${top}px` : 0],
    "m1g7c6eq-11": [({
      right
    }) => right ? `${right}px` : 0],
    "m1g7c6eq-12": [({
      bottom
    }) => bottom ? `${bottom}px` : 0],
    "m1g7c6eq-13": [({
      left
    }) => left ? `${left}px` : 0]
  }
});
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "wrlirkb",
  vars: {
    "wrlirkb-0": [({
      marginTop
    }) => marginTop ? `${marginTop}px` : 0],
    "wrlirkb-1": [({
      marginRight
    }) => marginRight ? `${marginRight}px` : 0],
    "wrlirkb-2": [({
      marginBottom
    }) => marginBottom ? `${marginBottom}px` : 0],
    "wrlirkb-3": [({
      marginLeft
    }) => marginLeft ? `${marginLeft}px` : 0]
  }
});

require("./Content.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./Content.tsx");